// ============================================
// MyPage Module - Events (ES6)
// 마이페이지 이벤트 핸들러
// ============================================

import {
  openCarbonModal,
  closeCarbonModal,
  openCarbonRechargeModal,
  closeCarbonRechargeModal,
  filterCarbonHistory,
  selectCarbonPackage,
  openAvatarUploadModal
} from './index.js';

import { openProfileManager } from '../profile/index.js';
import { openNicknameModal, handleLogout } from '../auth/index.js';
import { showToast } from '../utils.js';

// ============================================
// MyPage Events Initialization
// ============================================

export function initMyPageEvents() {
  // === Carbon Modal ===
  const carbonBackBtn = document.querySelector('#carbonFullModal .carbon-back-btn');
  if (carbonBackBtn) {
    carbonBackBtn.addEventListener('click', closeCarbonModal);
  }

  const carbonRechargeBtn = document.querySelector('#carbonFullModal .carbon-recharge-btn');
  if (carbonRechargeBtn) {
    carbonRechargeBtn.addEventListener('click', openCarbonRechargeModal);
  }

  // Carbon Filter Tabs (event delegation)
  const carbonFilterTabs = document.querySelector('.carbon-filter-tabs');
  if (carbonFilterTabs) {
    carbonFilterTabs.addEventListener('click', (e) => {
      const tab = e.target.closest('.carbon-filter-tab');
      if (tab && tab.dataset.filter) {
        filterCarbonHistory(tab.dataset.filter);
      }
    });
  }

  // === Carbon Recharge Modal ===
  const carbonRechargeBackdrop = document.querySelector('#carbonRechargeModal .bottom-sheet-backdrop');
  if (carbonRechargeBackdrop) {
    carbonRechargeBackdrop.addEventListener('click', closeCarbonRechargeModal);
  }

  // Carbon Package Items (event delegation)
  const carbonPackageList = document.querySelector('.carbon-package-list-v2');
  if (carbonPackageList) {
    carbonPackageList.addEventListener('click', (e) => {
      const packageItem = e.target.closest('.carbon-package-item');
      if (packageItem) {
        const amount = parseInt(packageItem.dataset.amount);
        const price = parseInt(packageItem.dataset.price);
        if (amount && price) {
          selectCarbonPackage(amount, price);
        }
      }
    });
  }

  // === MyPage Avatar Upload ===
  const myPageAvatar = document.querySelector('.sns-profile-avatar');
  if (myPageAvatar) {
    myPageAvatar.addEventListener('click', openAvatarUploadModal);
  }

  // === MyPage Action Buttons ===
  document.querySelectorAll('.sns-action-btn').forEach(btn => {
    const text = btn.textContent.trim();
    if (text === '정보 수정') {
      btn.addEventListener('click', openNicknameModal);
    } else if (text === '프로필 관리') {
      btn.addEventListener('click', openProfileManager);
    }
  });

  // === MyPage Carbon Section ===
  const carbonSection = document.querySelector('.sns-carbon-section');
  if (carbonSection) {
    carbonSection.addEventListener('click', openCarbonModal);
  }

  // === MyPage Inline Settings (event delegation) ===
  const settingsSection = document.querySelector('.mypage-settings-section');
  if (settingsSection) {
    settingsSection.addEventListener('click', (e) => {
      const row = e.target.closest('.mypage-settings-row');
      if (!row) return;

      const action = row.dataset.action;
      switch (action) {
        case 'profile-manager':
          openProfileManager();
          break;
        case 'logout':
          handleLogout();
          break;
        case 'coming-soon':
          showToast('준비 중입니다');
          break;
      }
    });
  }

  console.log('[MyPage Events] 이벤트 리스너 초기화 완료');
}
